import { render, staticRenderFns } from "./smartProduct.vue?vue&type=template&id=2e604bdd&scoped=true"
import script from "./smartProduct.vue?vue&type=script&lang=js"
export * from "./smartProduct.vue?vue&type=script&lang=js"
import style0 from "./smartProduct.vue?vue&type=style&index=0&id=2e604bdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e604bdd",
  null
  
)

export default component.exports